import React, { useState, useEffect } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
import { Card, Grid, Checkbox } from '@scuf/common'
import useDAPC from './useDAPC'

const PlantaAcidoDAPC = ({ height, getData }) => {
    const { checkPA, fCalculateLenghtPA, setCheckPA, fCalculateEnabledDisabledPA } = useDAPC(null)
    const [option, setOption] = useState(null)

    const categories = [
        'Bomba agua desmineralizada',
        'Concentrado Acido Torre Absorción',
        'Concentrado Acido Torre Secado',
        'Estanque 01 a torre absorción',
        'Estanque 02 a Estanque 03',
        'Flujo de agua a torre abs intermedia',
        'Nivel Estanque 01',
        'Nivel Estanque 02',
        'Nivel Estanque 03',
        'Temp. Estanque 2',
        'Temp. Torre Enfriamiento',
        'Válvula agua torre enfriamiento',
        'Velocidad bombas estanque 03',
    ]
    const colors = ['#1792e5', '#7eb338', '#ffc627', '#f37021', '#ee3124', '#9b59b6', '#b65959', '#8dcdff', '#9e9e9e', '#1792e5', '#7eb338', '#ffc627', '#f37021']

    useEffect(() => {
        if (getData && getData.length > 0) {
            let _labels = [], _data = [], band = 0, _height = 100 / fCalculateLenghtPA(), top = 0

            for (let index = 0; index < categories.length; index++) {
                if (fCalculateEnabledDisabledPA()[index] === 1) {
                    _data.push({
                        type: 'line',
                        name: categories[index],
                        data: getData.filter(n => n.Detalle === categories[index]).map((x, i) => [new Date(x.FechaHora).getTime(), x.Valor]),
                        yAxis: band,
                        color: colors[index],
                        gridLineWidth: 0
                    })
                    band = band + 1

                    _labels.push({
                        labels: {
                            align: 'right',
                            x: -3
                        },
                        title: {
                            text: categories[index]
                        },
                        height: _height + '%',
                        top: top + '%',
                        resize: {
                            enabled: true
                        },
                        gridLineWidth: 0,
                        offset: 0,
                    })

                    top = top + _height

                    if (fCalculateLenghtPA() === band) {
                        setOption(
                            {
                                rangeSelector: { buttons: [] },
                                title: {
                                    text: ''
                                },
                                yAxis: _labels,

                                tooltip: {
                                    split: true
                                },
                                series: _data,
                                credits: {
                                    enabled: false
                                }
                            }
                        )
                    }
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkPA])

    return (
        <>
            <Grid.Column width={10} sWidth={12} xsWidth={12} className='div-pe-0px-xs'>
                <Card className='m-0 p-0'>
                    {
                        option && (checkPA.btn1 || checkPA.btn2 || checkPA.btn3 || checkPA.btn4 || checkPA.btn5 || checkPA.btn6 || checkPA.btn7 || checkPA.btn8 || checkPA.btn9 || checkPA.btn10 || checkPA.btn11 || checkPA.btn12 || checkPA.btn13) ?
                            <div className='line-custom'>
                                <HighchartsReact
                                    constructorType='stockChart'
                                    style={{ width: '100%' }}
                                    highcharts={Highcharts}
                                    options={option}
                                    containerProps={{ style: { height: height, width: '100%' } }}
                                />
                            </div>
                            :
                            <div className='letter-origin'>...No hay datos</div>
                    }
                </Card>
            </Grid.Column>
            <Grid.Column width={2} sWidth={12} xsWidth={12} className='div-ps-0px-xs'>
                <Card className='m-0 p-0'>
                    <Card.Header>
                        <div className='letter-origin mb-2'>VARIABLES</div>
                    </Card.Header>
                    <Grid.Row>
                        <div className='mx-2'>
                            <Checkbox label="Seleccionar Todo" toggle={true} checked={checkPA.btn1 && checkPA.btn2 && checkPA.btn3 && checkPA.btn4 && checkPA.btn5 && checkPA.btn6 && checkPA.btn7 && checkPA.btn8 && checkPA.btn9 && checkPA.btn10 && checkPA.btn11 && checkPA.btn12 && checkPA.btn13? true : false}
                                onChange={(checked) =>
                                    checked ?
                                        setCheckPA({ btn1: true, btn2: true, btn3: true, btn4: true, btn5: true, btn6: true, btn7: true, btn8: true, btn9: true, btn10: true, btn11: true, btn12: true, btn13: true })
                                        :
                                        setCheckPA({ btn1: false, btn2: false, btn3: false, btn4: false, btn5: false, btn6: false, btn7: false, btn8: false, btn9: false, btn10: false, btn11: false, btn12: false, btn13: false  })
                                }
                            />
                            <Checkbox label="Bomba agua desmineralizada" onChange={(checked) => { setCheckPA({ ...checkPA, btn1: checked }) }} checked={checkPA.btn1} />
                            <Checkbox label="Concentrado ácido Torre Absorción" onChange={(checked) => setCheckPA({ ...checkPA, btn2: checked })} checked={checkPA.btn2} />
                            <Checkbox label="Concentrado ácido Torre Secado" onChange={(checked) => setCheckPA({ ...checkPA, btn3: checked })} checked={checkPA.btn3} />
                            <Checkbox label="Estanque 01 a torre absorción" onChange={(checked) => { setCheckPA({ ...checkPA, btn4: checked }) }} checked={checkPA.btn4} />
                            <Checkbox label="Estanque 02 a Estanque 03" onChange={(checked) => setCheckPA({ ...checkPA, btn5: checked })} checked={checkPA.btn5} />
                            <Checkbox label="Flujo de agua a torre abs intermedia" onChange={(checked) => setCheckPA({ ...checkPA, btn6: checked })} checked={checkPA.btn6} />
                            <Checkbox label="Nivel estanque 01" onChange={(checked) => { setCheckPA({ ...checkPA, btn7: checked }) }} checked={checkPA.btn7} />
                            <Checkbox label="Nivel estanque 02" onChange={(checked) => setCheckPA({ ...checkPA, btn8: checked })} checked={checkPA.btn8} />
                            <Checkbox label="Nivel estanque 03" onChange={(checked) => setCheckPA({ ...checkPA, btn9: checked })} checked={checkPA.btn9} />
                            <Checkbox label="Temperatura estanque 2" onChange={(checked) => setCheckPA({ ...checkPA, btn10: checked })} checked={checkPA.btn10} />
                            <Checkbox label="Temperatura torre Enfriamiento" onChange={(checked) => setCheckPA({ ...checkPA, btn11: checked })} checked={checkPA.btn11} />
                            <Checkbox label="Válvula agua torre enfriamiento" onChange={(checked) => setCheckPA({ ...checkPA, btn12: checked })} checked={checkPA.btn12} />
                            <Checkbox label="Válvula agua torre enfriamiento" onChange={(checked) => setCheckPA({ ...checkPA, btn13: checked })} checked={checkPA.btn13} />
                        </div>
                    </Grid.Row>
                </Card>
            </Grid.Column>
        </>
    )
}

export default PlantaAcidoDAPC